import Model from 'ducker-model';

// 1.定义property
const property = {
  id: String,
  title: String,
  source: String,
  time: String,
  url: String,
};

// 2.定义replacedKeyFromPropertyName
const replacedKeyFromPropertyName = {
  id: {
    property: 'art_code',
    defaultValue: '',
  },
  title: {
    property: 'title',
    defaultValue: '--',
  },
  source: {
    property: 'new_column_code',
    defaultValue: '--',
    // eslint-disable-next-line camelcase
    computed: (new_column_code) => {
      const configure = {
        1: '发行运作',
        2: '分红送配',
        3: '定期报告',
        4: '人事调整',
        5: '基金销售',
        6: '其他公告',
      };
      return configure[new_column_code] ? configure[new_column_code] : '';
    },
  },
  time: {
    property: 'notice_date',
    defaultValue: '--',
  },
  url: {
    property: 'URL',
    defaultValue: 'https://appunit.1234567.com.cn/fundfiles/announcementtext.html',
  },
};
export default new Model(property, replacedKeyFromPropertyName);
